import * as React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AdminProtectedRoute } from '../../App/Routes';
import { AdminUsers } from './AdminUsers';
import { NotFoundRedirect } from '../../App/NotFoundRedirect';
import { setImpersonationUid } from '../../../helpers/impersonationHelpers';
import { useEffect } from 'react';
import { useGetAdminUserLazyQuery } from '../../../models/graphql';
import { Loader } from '../../../components/containers/Loader';
import { setSessionToast } from '../../../helpers/sessionToastHelpers';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';

const AdminImpersonatePath = (): JSX.Element => {
  const { '*': userId } = useParams();
  const [getUserQuery] = useGetAdminUserLazyQuery();

  useEffect(() => {
    if (userId) {
      getUserQuery({ variables: { userId } })
        .then(result => {
          if (result.error) {
            setSessionToast({
              summary: `Impersonation Error for User ${userId}`,
              detail: remapApolloErrors(result.error),
              severity: 'error'
            });
          } else if (result.data) {
            const user = result.data.admin_user;
            if (!user.fromLegacy || user.migratedToOverhaul) {
              setImpersonationUid(userId);
            } else {
              setSessionToast({
                summary: `Impersonation Error for User ${userId}`,
                detail: 'User is not currently in the overhaul',
                severity: 'error'
              });
            }
          }
        })
        .finally(() => {
          window.location.assign('/');
        });
    }
  }, [getUserQuery, userId]);

  if (userId) {
    return <Loader variation={'dark'} size={'large'} type={'overlay'} />;
  } else {
    return <Navigate to={'/'} replace />;
  }
};

export const Admin = (): JSX.Element => {
  return (
    <AdminProtectedRoute>
      <Routes>
        <Route path={'users'} element={<AdminUsers />} />
        <Route path={'impersonate/*'} element={<AdminImpersonatePath />} />
        <Route path={'*'} element={<NotFoundRedirect to={'users'} />} />
      </Routes>
    </AdminProtectedRoute>
  );
};
